import { Lang } from 'cat-shared/utils'

export default {
  [Lang.EN]: {
    header: 'Settings',
    tabs: {
      appSettings: 'App',
      personalDetails: 'User details',
      profilePicture: 'Avatar',
      password: 'Password',
      payment: 'Payment info',
      deactivation: 'Deactivation',
    },
    appSettings: {
      fields: {
        theme: {
          label: 'Theme',
          options: {
            light: 'Light',
            dark: 'Dark',
          },
        },
        lang: {
          label: 'Language',
          options: {
            en: 'English',
            pl: 'Polish',
          },
        },
      },
    },
    avatar: {
      sliders: {
        zoom: 'Zoom',
        rotation: 'Rotation',
      },
      messages: {
        warning: 'Allowed formats: png, jpg, jpeg.',
      },
    },
    payment: {
      buttons: {
        makePayment: 'Make payment',
        seeTransactionDetails: 'Transaction details',
      },
    },
    deactivation: {
      info: 'You can use this form to completely deactivate your account. Deactivation means your profile and all your actions will be removed. After you submit, you will receive an email with deactivation link which you need to open in order to confirm your decision and finalize deactivation. You will be able to use the same email to register with us again, but your content will never be restored.',
      label: 'I would like to deactivate my account.',
    },
    buttons: {
      upload: 'Upload',
      open: 'Open ...',
      clear: 'Clear',
      reset: 'Reset',
    },
  },
}
